import React from 'react';
import PropTypes from 'prop-types';

const NetworkBanner = (props) => {
    const { show = false } = props;
    return ( 
        <>
            { 
                show ? (
                    <div className="w-full flex bg-red-800 p-2 fixed bottom-0 text-xs text-white font-bold">
                        You are offline. Some of the functionalities will not work.
                    </div>
                ) : null
            }
        </>
    )
}
NetworkBanner.propTypes = {
    show : PropTypes.bool
};

export default NetworkBanner;